import { ts } from '../utils/textStyle';
import type { RunSnapshot } from './runState';

export interface DebugMetrics {
  fps: number;
  enemyCount: number;
  objectPoolCount: number;
}

export class DebugOverlay {
  private readonly text: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.text = scene.add.text(8, 8, '', ts({
      fontFamily: 'monospace',
      fontSize: '12px',
      color: '#ffffff',
      backgroundColor: '#000000cc',
      padding: { x: 6, y: 5 },
      lineSpacing: 3,
    }));
    this.text.setDepth(1000);
    this.text.setScrollFactor(0);
  }

  update(snapshot: RunSnapshot, metrics: DebugMetrics) {
    this.text.setText([
      `phase ${snapshot.phase}`,
      `seed ${snapshot.seed}`,
      `wave ${snapshot.wave}/${snapshot.maxWave > 0 ? snapshot.maxWave : '∞'}  time ${snapshot.waveTimeLeft.toFixed(1)}`,
      `fps ${metrics.fps.toFixed(0)}  enemies ${metrics.enemyCount}`,
      `hp ${snapshot.hp.toFixed(0)} / ${snapshot.maxHp}`,
      `level ${snapshot.level}  xp ${snapshot.xp}/${snapshot.nextLevelXp}`,
      `dps ${snapshot.stats.damageDealt.toFixed(0)}`,
      `hits ${snapshot.stats.hitsTaken}  dmg ${snapshot.stats.damageTaken.toFixed(0)}`,
      `materials ${snapshot.materials}  total ${snapshot.stats.materialsPicked}`,
      `pool ${metrics.objectPoolCount}`,
    ]);
  }

  setVisible(visible: boolean) {
    this.text.setVisible(visible);
  }
}

export function isDebugEnabled() {
  return new URLSearchParams(window.location.search).get('debug') === '1';
}
